export const RESET_CLUB_ISFETCHING = 'RESET_CLUB_ISFETCHING';
export const GET_CLUB_REQUEST = 'GET_CLUB_REQUEST';
export const GET_CLUB_SUCCESS = 'GET_CLUB_SUCCESS';
export const LIST_CLUBS_REQUEST = 'LIST_CLUBS_REQUEST';
export const CLUB_LIST_REQUESTING = 'CLUB_LIST_REQUESTING';
export const CLUB_OBJECT_REQUESTING = 'CLUB_OBJECT_REQUESTING';
export const LIST_CLUBS_SUCCESS = 'LIST_CLUBS_SUCCESS';
